export default __webpack_public_path__ + "static/media/cbr.aef9687b.PNG";